import { render, staticRenderFns } from "./RectangleCheckbox.vue?vue&type=template&id=0c88cdb5&lang=pug&"
import script from "./RectangleCheckbox.vue?vue&type=script&lang=js&"
export * from "./RectangleCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports